import React from 'react'
import styles from './Products.module.css'
import ProductList from '../ProductList/ProductList'
export default function Products() {
  return <>
    
   <ProductList />
    
    </>
  
}
